import React,{useState,}from 'react'
import { Form,Input,App, Radio, Modal} from 'antd';
import GetUserDept from '../../cpn/GetUserDept';
import { useBnsGoodsAddMutation } from '../../store/BnsKeJiApi';
import ProjectTypeSelect from './ProjectTypeSelect';
import {PlusSquareOutlined} from '@ant-design/icons';
const {TextArea} = Input
function ProjectAdd() {    
    const {message} = App.useApp()
    const [open,setOpen] = useState(false)
    const [form] = Form.useForm();
    const [add]  = useBnsGoodsAddMutation()
    const [info,setInfo] = useState({
        bg_bxm_id:'',
        bg_bxm_num:'',
        bg_content:'',
        bg_type_id:'',
        bg_state:'1'
    });
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增项目</a>
                <Modal
                    title='新增项目'  
                    open={open}
                    width={800}
                    onCancel={() => {setOpen(false)}}
                    onOk={() => {
                        form.resetFields();  
                        add({
                            "bg_cid" : localStorage.getItem('eu_id'),
                            "bg_cname" : localStorage.getItem('eu_name'),
                            "bg_e_id" : localStorage.getItem('e_id'),
                            "bg_name" : info.bg_name,
                            "bg_dept_id" : info.bg_dept_id,
                            "bg_dept_name" : info.bg_dept_name,
                            "bg_content" : info.bg_content,
                            "bg_type_id" : info.bg_type_id,
                            "bg_state" : info.bg_state,
                        }).then((res) => {
                            if (res.data.Status === 'success') {
                                message.info('新增成功！');
                                setOpen(false)
                            }
                            if (res.data.Status === "fail") {
                                message.error('新增失败！'+res.data.Message)
                            }
                        })      
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 4 }}  
                                            
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bg_dept_id:e,bg_dept_name:f}))
                            }}
                        />
                        <ProjectTypeSelect
                            label='项目类型'
                            required
                            wrapperCol={{span:10}} 
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bg_type_id:e}))
                            }}
                        />
                        <Form.Item name="name" label='项目名称' wrapperCol={{span:10}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bg_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item name="remark" label='项目说明' wrapperCol={{span:18}}>
                            <TextArea 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bg_content:e.target.value}))}}
                                rows={5}
                            />
                        </Form.Item> 
                        <Form.Item name="bg_state" label='项目状态' wrapperCol={{span:18}}>
                            <Radio.Group onChange={(e) => {setInfo(prevState=>({...prevState,bg_state:e.target.value}))}}>
                                <Radio value='1'>开发中</Radio>
                                <Radio value='2'>使用中</Radio>
                                <Radio value='3'>已停用</Radio>
                            </Radio.Group>                       
                        </Form.Item> 
                       
                    </Form>
                </Modal>
            </>
        )
}

export default ProjectAdd